<template>
  <b-sidebar
    id="troca-empresa-sidebar"
    bg-variant="white"
    right
    backdrop
    shadow
  >
    <div class="text-center">
      <feather-icon
        size="32"
        class="mr-1"
        icon="HeartIcon"
      />

      <!-- Name -->
      <b-card-text class="mt-2 h4 color-inherit text-reset">
        Meus Relacionamentos
      </b-card-text>
    </div>

    <b-list-group class="mt-3 rounded-0">
      <b-list-group-item
        v-for="item in minhasEmpresas"
        :key="item.cnpj"
        class="bg-transparent"
      >
        <b-button
          variant="outline-primary"
          block
          @click="trocar(item)"
        >
          <feather-icon icon="RefreshCwIcon" />

          {{ item.razaoSocial }}
        </b-button>
      </b-list-group-item>
    </b-list-group>
  </b-sidebar>
</template>

<script>
import {
  BSidebar, BListGroup, BListGroupItem, BCardText,
} from 'bootstrap-vue'

export default {
  components: {
    BSidebar,
    BListGroup,
    BListGroupItem,
    BCardText,
  },
  computed: {
    minhasEmpresas() {
      return this.$store.state.conta.minhasEmpresas
    },
  },
  methods: {
    trocar(item) {
      this.$store.dispatch('auth/trocarConta', item.id).then(res => {
        this.$ability.update(res.data.ability)
        const queryString = window.location.search
        const urlParams = new URLSearchParams(queryString)
        if (urlParams.has('redirect')) {
          this.$router.replace(decodeURIComponent(urlParams.get('redirect')))
        } else {
          this.$router.go('home')
        }
      })
    },
  },
}
</script>
